import {
  getStorylineSettings,
  getStorylineSettingsStatus,
} from '@ms/yammer-data/dist/domains/storylineSettings/selectors';

import { useSelector } from '../useSelector';

type UseStorylineSettings = () => ReturnType<typeof getStorylineSettings>;
export const useStorylineSettings: UseStorylineSettings = () => useSelector(getStorylineSettings);

type UseStorylineSettingsStatus = () => ReturnType<typeof getStorylineSettingsStatus>;
export const useStorylineSettingsStatus: UseStorylineSettingsStatus = () => useSelector(getStorylineSettingsStatus);
